import { __assign } from "tslib";
import React, { useContext } from 'react';
import { GenericArea, SeatingViewerContext, isPlaceOccupied, COLORS } from '@wix/seating-common-components';
import s from './area.scss';
export var Area = function (_a) {
    var definition = _a.definition, _b = _a.definition, categoryId = _b.categoryId, seats = _b.seats;
    var _c = useContext(SeatingViewerContext), onPlaceClick = _c.onPlaceClick, placesStock = _c.placesStock, onPlaceMouseEnter = _c.onPlaceMouseEnter, onPlaceMouseLeave = _c.onPlaceMouseLeave, currentlyClickedPlaceId = _c.currentlyClickedPlaceId, mobile = _c.mobile;
    var place = seats[0];
    var placeId = place === null || place === void 0 ? void 0 : place.id;
    var placeClicked = currentlyClickedPlaceId && currentlyClickedPlaceId === placeId;
    var occupied = isPlaceOccupied(place, placesStock);
    var handleSeatClick = function () {
        if (occupied) {
            return;
        }
        onPlaceClick === null || onPlaceClick === void 0 ? void 0 : onPlaceClick(place, categoryId, definition);
    };
    var getDefinition = function () {
        if (occupied) {
            return __assign(__assign({}, definition), { shapeColor: COLORS.TRANSPARENT });
        }
        if (placeClicked) {
            return __assign(__assign({}, definition), { shapeColor: COLORS.WHITE });
        }
        return definition;
    };
    return (React.createElement(GenericArea, { className: "".concat(occupied ? undefined : s.area, " ").concat(mobile ? s.mobile : undefined), labelClassName: s.label, definition: getDefinition(), dataHook: place === null || place === void 0 ? void 0 : place.id, cursor: occupied ? 'default' : 'pointer', onClick: handleSeatClick, onMouseEnter: onPlaceMouseEnter ? function (e) { return onPlaceMouseEnter({ event: e, seat: place, categoryId: categoryId }); } : null, onMouseLeave: onPlaceMouseLeave ? function (e) { return onPlaceMouseLeave({ event: e, seat: place, categoryId: categoryId }); } : null }));
};
//# sourceMappingURL=area.js.map